/* eslint-disable @typescript-eslint/no-explicit-any */
import {
	QueryClient,
	UseMutationOptions,
	UseQueryOptions,
} from '@tanstack/react-query';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
			staleTime: 1000 * 60,
		},
	},
});

export type QueryConfig<
	T extends (...args: any[]) => Promise<any>,
	TError = any, // Changé Error en TError (any par défaut)
> = Omit<
	UseQueryOptions<
		Awaited<ReturnType<T>>,
		TError,
		Awaited<ReturnType<T>>,
		any
	>,
	'queryKey' | 'queryFn'
>;

export type ApiFnReturnType<
	FnType extends (...args: any) => Promise<any>,
> = Awaited<ReturnType<FnType>>;

export type TMutationConfig<
	MutationFnType extends (...args: any) => Promise<any>,
	TError = any,
> = UseMutationOptions<
	ApiFnReturnType<MutationFnType>,
	TError,
	Parameters<MutationFnType>[0]
>;
